module.exports = __webpack_public_path__ + "static/img/tips.7bd5048.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/door/tips.png
// module id = lbGz
// module chunks = 1